import { Component, OnInit, inject } from '@angular/core';
import { takeUntil, tap } from 'rxjs/operators';

import { PollParserType } from 'src/app/core/api/models';
import { InboxesService } from 'src/app/core/api/services';
import { EventTypes } from 'src/app/core/constants/event-types';
import { AppDomService } from 'src/app/core/services/dom.service';
import { BaseIndexPageComponent } from '../../../shared/base/components/base-index-page.component';
import { PollParserInboxesModalComponent } from '../poll-parser-inboxes/poll-parser-inboxes-modal/poll-parser-inboxes-modal.component';
import { PollParserLotteryModalComponent } from '../poll-parser-inboxes/poll-parser-lottery-modal/poll-parser-lottery-modal.component';

@Component({
    selector: 'app-base-parser-index',
    template: ``,
    standalone: false
})
export abstract class BaseParserIndexComponent
  extends BaseIndexPageComponent
  implements OnInit
{
  inboxService = inject(InboxesService);

  pageName = 'pollParsers';
  isVisiblePollParserInboxes: boolean = false;
  pollParserId: any;
  targetAnswer: any;
  pollParserFormula: any[];
  get PollParserType() {
    return PollParserType;
  }

  constructor() {
    super();
  }

  ngOnInit() {
    try {
      super.ngOnInit();
      this.pageConfig.isAddBtnWithLoading = true;
    } catch (error) {
      this.loggerService.logError(this.tagName, error, EventTypes.services);
    }
  }

  configTableColumns() {
    this.tableColumns = [
      { title: this.localizer.title, name: 'title', hasSearch: true },
      {
        title: this.localizer.active,
        name: 'isActive',
        type: 'boolean',
        hasSearch: true,
      },
      {
        title: this.localizer.startDate,
        name: 'startDateTime',
        hasSearch: true,
        type: 'dateTime',
      },
      {
        title: this.localizer.endDate,
        name: 'endDateTime',
        hasSearch: true,
        type: 'dateTime',
      },
    ];
  }

  //#region Api

  abstract updateIsActiveApi(pollParserId: number, isActive: boolean): void;
  abstract getPollParserFormulaApi(
    pollParserId: string,
    type: 'inbox' | 'lottery'
  ): void;

  // //#endregion

  onUpdateIsActive(pollParserId: number, isActive: boolean) {
    this.updateIsActiveApi(pollParserId, isActive);
  }

  //lottery component
  onPollParserLottery(parserId, pollParserFormula) {
    const modalResult = this.dialogService.openModal({
      component: PollParserLotteryModalComponent,
      data: {
        pollParserId: parserId,
        pollParserFormula: pollParserFormula,
      },
    });

    const sub = modalResult
      .afterClosed()
      .pipe(
        takeUntil(this.onDestroy$),
        tap(() => {
          AppDomService.removeModalScrollClassFromHtml();
        })
      )
      .subscribe((res) => {
        this.pollParserId = res.parserId;
        this.targetAnswer = res.targetAnswer;
      });
  }

  //inbox component
  onPollParserInboxes(parserId, pollParserFormula) {
    const modalResult = this.dialogService.openModal({
      component: PollParserInboxesModalComponent,
      data: {
        pollParserId: parserId,
        pollParserFormula: pollParserFormula,
      },
    });

    const sub = modalResult
      .afterClosed()
      .pipe(
        takeUntil(this.onDestroy$),
        tap(() => {
          AppDomService.removeModalScrollClassFromHtml();
        })
      )
      .subscribe((res) => {
        this.pollParserId = res.parserId;
        this.targetAnswer = res.targetAnswer;
        this.isVisiblePollParserInboxes = true;
      });
  }

  getPollParserFormula(parserId, type: 'lottery' | 'inbox') {
    this.unSubs();
    this.pageConfig.loading = true;
    this.getPollParserFormulaApi(parserId, type);
  }
}
